var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { makeStyles, FormControl, FormHelperText, Grid, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React from 'react';
import { getCountryNames } from '../data/countries';
import { getUSStateNames } from '../data/us-states';
import { getCAProvinceNames } from '../data/ca-provinces';
var useStyles = makeStyles(function () {
    return {
        noPadding: {
            '&.MuiGrid-item': {
                padding: '0px'
            }
        }
    };
});
export function stateRequiredForCountry(country) {
    if (!country)
        return true;
    return country === 'United States' || country === 'Canada';
}
export function zipRequiredForCountry(country) {
    if (!country)
        return true;
    return (country === 'United States' ||
        country === 'Canada' ||
        country === 'United Kingdom' ||
        country === 'Germany' ||
        country === 'Switzerland' ||
        country === 'Australia' ||
        country === 'India' ||
        country === 'Italy' ||
        country === 'France' ||
        country === 'Netherlands');
}
export function ContactInformationForm(_a) {
    var errors = _a.errors;
    var classes = useStyles();
    var _b = __read(React.useState(errors), 2), formErrors = _b[0], setFormErrors = _b[1];
    var _c = __read(React.useState({
        country: '',
        state: ''
    }), 2), formState = _c[0], setFormState = _c[1];
    React.useEffect(function () {
        setFormErrors(errors);
    }, [errors]);
    return (React.createElement(Grid, { container: true, spacing: 4 },
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(FormControl, { variant: "outlined", fullWidth: true },
                React.createElement(TextField, { name: "email", fullWidth: true, label: "Email", variant: "outlined", error: !!formErrors.email, helperText: formErrors.email || '', onChange: function () { return setFormErrors(__assign(__assign({}, formErrors), { email: '' })); } }))),
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(FormControl, { variant: "outlined", fullWidth: true },
                React.createElement(TextField, { error: !!formErrors.company, fullWidth: true, helperText: formErrors.company || '', label: "Company name", name: "company", onChange: function () { return setFormErrors(__assign(__assign({}, formErrors), { company: '' })); }, variant: "outlined" }))),
        React.createElement(Grid, { container: true, item: true, justifyContent: "center", xs: 12, className: classes.noPadding },
            React.createElement(Grid, { item: true, xs: 5 },
                React.createElement(FormControl, { variant: "outlined", fullWidth: true },
                    React.createElement(TextField, { error: !!formErrors.firstName, fullWidth: true, helperText: formErrors.firstName || '', label: "First name", name: "firstName", onChange: function () { return setFormErrors(__assign(__assign({}, formErrors), { firstName: '' })); }, variant: "outlined" }))),
            React.createElement(Grid, { item: true, xs: 1 }),
            React.createElement(Grid, { item: true, xs: 5 },
                React.createElement(FormControl, { variant: "outlined", fullWidth: true },
                    React.createElement(TextField, { error: !!formErrors.lastName, fullWidth: true, helperText: formErrors.lastName || '', label: "Last name", name: "lastName", onChange: function () { return setFormErrors(__assign(__assign({}, formErrors), { lastName: '' })); }, variant: "outlined" })))),
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(FormControl, { variant: "outlined", fullWidth: true },
                React.createElement(TextField, { error: !!formErrors.phone, fullWidth: true, helperText: formErrors.phone || '', label: "Phone", name: "phone", onChange: function () { return setFormErrors(__assign(__assign({}, formErrors), { phone: '' })); }, variant: "outlined" }))),
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(FormControl, { variant: "outlined", fullWidth: true, error: !!errors.country },
                React.createElement(Autocomplete, { autoComplete: true, autoSelect: true, getOptionLabel: function (option) { return option; }, id: "country-select", onChange: function (e, val) {
                        setFormErrors(__assign(__assign({}, formErrors), { country: '' }));
                        setFormState(__assign(__assign({}, formState), { country: val, state: '' }));
                    }, options: getCountryNames(), renderInput: function (params) { return (React.createElement(TextField, __assign({}, params, { error: !!formErrors.country, label: "Country", name: "country", variant: "outlined" }))); }, value: formState.country || null }),
                React.createElement(FormHelperText, null, formErrors.country || ''))),
        stateRequiredForCountry(formState.country) ? (React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(FormControl, { variant: "outlined", fullWidth: true, error: !!formErrors.state },
                React.createElement(Autocomplete, { autoComplete: true, autoSelect: true, getOptionLabel: function (option) { return option; }, id: "state-select", options: formState.country === 'United States' ? getUSStateNames() : getCAProvinceNames(), onChange: function (e, val) {
                        setFormErrors(__assign(__assign({}, formErrors), { state: '' }));
                        setFormState(__assign(__assign({}, formState), { state: val }));
                    }, renderInput: function (params) { return (React.createElement(TextField, __assign({}, params, { error: !!formErrors.state, label: "State / Province", variant: "outlined", name: "state" }))); }, value: formState.state || null }),
                React.createElement(FormHelperText, null, formErrors.state || '')))) : null,
        zipRequiredForCountry(formState.country) ? (React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(FormControl, { variant: "outlined", fullWidth: true },
                React.createElement(TextField, { error: !!formErrors.postalCode, fullWidth: true, helperText: formErrors.postalCode || '', label: "Zip/Postal code", name: "postalCode", onChange: function () { return setFormErrors(__assign(__assign({}, formErrors), { postalCode: '' })); }, variant: "outlined" })))) : null));
}
//# sourceMappingURL=ContactInformationForm.js.map